/**
 * RPC names deployed on TMS (see supabase/tms-handoff/directory_intake_rpcs.sql).
 * Anonymous registration uses these with the anon Supabase key.
 */
export const DIRECTORY_INTAKE_RPC = {
  validateListing: "validate_directory_run_listing_public",
  submitDraft: "submit_public_directory_participant_draft",
  submitFullCertModules: "submit_public_directory_participant_drafts_full_cert_modules",
};

/** @param {import('@supabase/supabase-js').SupabaseClient} supabase */
export async function validateDirectoryRunListing(supabase, { runKind, runCode, directoryChannel }) {
  const { data, error } = await supabase.rpc(DIRECTORY_INTAKE_RPC.validateListing, {
    p_run_kind: runKind,
    p_run_code: runCode,
    p_directory_channel: directoryChannel,
  });
  if (error) {
    return { ok: false, error: error.message || String(error) };
  }
  if (data && typeof data === "object" && "ok" in data) {
    return { ok: data.ok === true, raw: data };
  }
  return { ok: false, error: "unexpected_response" };
}

/** @param {import('@supabase/supabase-js').SupabaseClient} supabase */
export async function submitDirectoryParticipantDraft(supabase, payload) {
  const { data, error } = await supabase.rpc(DIRECTORY_INTAKE_RPC.submitDraft, {
    p_run_kind: payload.runKind,
    p_run_code: payload.runCode,
    p_directory_channel: payload.directoryChannel,
    p_entry_channel: payload.entryChannel,
    p_participant_data: payload.participantData,
  });
  if (error) {
    return { ok: false, error: error.message || String(error) };
  }
  if (data && typeof data === "object" && data.ok === true) {
    return { ok: true, draftId: data.draft_id, raw: data };
  }
  return { ok: false, error: (data && data.error) || "submit_failed", raw: data };
}

/** @param {import('@supabase/supabase-js').SupabaseClient} supabase */
export async function submitDirectoryParticipantDraftsFullCertModules(supabase, payload) {
  const { data, error } = await supabase.rpc(DIRECTORY_INTAKE_RPC.submitFullCertModules, {
    p_cert_run_code: payload.certRunCode,
    p_directory_channel: payload.directoryChannel,
    p_entry_channel: payload.entryChannel,
    p_participant_data: payload.participantData,
    p_module_run_codes: payload.moduleRunCodes,
  });
  if (error) {
    return { ok: false, error: error.message || String(error) };
  }
  if (data && typeof data === "object" && data.ok === true) {
    return { ok: true, draftIds: data.draft_ids, raw: data };
  }
  return { ok: false, error: (data && data.error) || "submit_failed", raw: data };
}
